require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-موسيقى-مستقلة.json") })
        }
      }, "path---tags-موسيقى-مستقلة");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-موسيقى-مستقلة!./.cache/json/tags-موسيقى-مستقلة.json
// module id = 620
// module chunks = 231608221292675